module.exports = __webpack_public_path__ + "img/dropsSlots_600.7d06ba51.png";